import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { stopLoading } from '../../store/app/factory';

export function usePageLoader() {
  const dispatch = useDispatch();

  const isLoading = useSelector((state: { app: { isLoading: boolean } }) => state.app.isLoading);

  useEffect(() => {
    if (document.readyState === 'complete') {
      dispatch(stopLoading());
      return;
    }

    const loadHandler = () => {
      dispatch(stopLoading());

      window.removeEventListener('load', loadHandler);
    };

    window.addEventListener('load', loadHandler);
  }, []);

  return { isLoading };
}
